import styled from '@emotion/styled';

const ExplicitLyricsWrapper = styled('span')({
  '> span': {
    transform: 'translate(-1.5rem, -0.3rem)',
  },
});

export default ExplicitLyricsWrapper;
